/* Host-owned viewer analytics. No events or identifiers leave an embedded player's origin. */
(function () {
  'use strict';
  if (window.ahExperienceAnalytics) return;
  var actions = ['open','close','ready','error','room_change','size_change','finish_change','mode_change','reference_change','unit_change','launch','ar_start','apply'];
  var propertyKeys = ['room_id','mode','stage','print_id','width_m','height_m','framed','white_border','reference','unit','size','variant_id','frame_color','border','reason'];
  function allowed() {
    try { return navigator.doNotTrack !== '1' && !!window.Shopify.customerPrivacy.analyticsProcessingAllowed(); } catch (_) { return false; }
  }
  function init() {
    if (!allowed() || !window.ArthausAnalytics) return false;
    var config = window.__ahExperienceAnalyticsConfig || {};
    window.ArthausAnalytics.initAnalytics({ surface: 'marketplace', artist: 'marketplace', clientId: 'myarthaus', accountId: 'arthaus',
      loadScout: false, scoutEvents: false, canTrack: allowed, ga4MeasurementId: config.ga4MeasurementId,
      posthog: { key: 'phc_Nkcy0jwuaGR8iDSqhihFxeC7VqdhUiPYlVkFagKWZke', useExistingClient: true } });
    return true;
  }
  function sanitize(signal) {
    if (!signal || actions.indexOf(signal.action) < 0) return null;
    var properties = {};
    propertyKeys.forEach(function (key) {
      var value = signal.properties && signal.properties[key];
      if ((typeof value === 'string' && value.length <= 160) || typeof value === 'boolean' || (typeof value === 'number' && Number.isFinite(value))) properties[key] = value;
    });
    return { action: signal.action, properties: properties };
  }
  function create(context) {
    var tracker;
    return function (signal) {
      var event = sanitize(signal);
      if (!event || !init()) return;
      if (!tracker) tracker = window.ArthausAnalytics.createExperienceTracker(context, window.ArthausAnalytics.track, allowed);
      tracker(event);
    };
  }
  function bridge(frame, emit) {
    var token, sequence = 0;
    try { var bytes = crypto.getRandomValues(new Uint8Array(16)); token = Array.from(bytes, function (byte) { return byte.toString(16).padStart(2, '0'); }).join(''); } catch (_) { return function () {}; }
    var origin = 'https://www.taudalpoi.art';
    function receive(message) {
      if (message.origin !== origin || message.source !== frame.contentWindow) return;
      var data = message.data;
      if (!data) return;
      if (data.type === 'easel-viewer-ready-v1') {
        frame.contentWindow.postMessage({ type: 'easel-viewer-analytics-v1', token: token }, origin);
        return;
      }
      if (data.type !== 'easel-viewer-event-v1' || data.token !== token || !Number.isSafeInteger(data.sequence) || data.sequence <= sequence) return;
      var signal = sanitize(data.event);
      if (!signal) return;
      sequence = data.sequence; emit(signal);
    }
    window.addEventListener('message', receive);
    return function () { window.removeEventListener('message', receive); };
  }
  window.ahExperienceAnalytics = { create: create, bridge: bridge, allowed: allowed, contextForProduct: function (id, handle) {
    return allowed() && window.ArthausAnalytics ? window.ArthausAnalytics.experienceContextForProduct(id, handle) : {};
  } };
  // Unknown/denied consent drops events; granting consent never replays pre-consent interactions.
  if (window.Shopify && window.Shopify.loadFeatures && !window.Shopify.customerPrivacy) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {});
  }
}());
